import React, { useEffect, useState } from "react";
import { ApiPaths } from "../../Config/ApiPath";
import { BasicInfo } from "../../Config/BasicInfo";
import useAxiosHelper from "../../Common/AxiosHelper";
import Loader from "../../Components/Loader/Loader";
import { Col, Row } from "react-bootstrap";
import moment from "moment";

const BusinessReport = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [busnessData, setBusinessData] = useState("");
  const { AxiosGet, AxiosPost } = useAxiosHelper();
  const [loading, setLoading] = useState(false);
  const [dateFilter, setDateFilter] = useState("default");

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "startDate") {
      setStartDate(value);
    } else if (name === "endDate") {
      setEndDate(value);
    }
  };

  const handleDateFilterChange = (e) => {
    const value = e.target.value;
    setDateFilter(value);
    const today = moment().endOf("day");
    let start = "";
    let end = "";
    switch (value) {
      case "today":
        start = today.startOf("day").format("YYYY-MM-DD");
        end = today.format("YYYY-MM-DD");
        break;
      case "yesterday":
        start = today.subtract(1, "days").startOf("day").format("YYYY-MM-DD");
        end = today.endOf("day").format("YYYY-MM-DD");
        break;
      case "this_week":
        start = today.startOf("week").format("YYYY-MM-DD");
        end = today.endOf("week").format("YYYY-MM-DD");
        break;
      case "this_month":
        start = today.startOf("month").format("YYYY-MM-DD");
        end = today.endOf("month").format("YYYY-MM-DD");
        break;
      default:
        start = "";
        end = "";
        break;
    }
    setStartDate(start);
    setEndDate(end);
  };
  const FetchData = async (isReset = false) => {
    console.log("startDate", startDate);
    console.log("endDate", endDate);
    isReset = isReset == true ?? false;
    try {
      const queryParams = {
        maxLevels: 200,
      };
      if (isReset == false) {
        if (startDate) {
          queryParams.fromDate = startDate;
        }
        if (endDate) {
          queryParams.toDate = endDate;
        }
      }

      setLoading(true);

      const response = await AxiosGet(
        `${ApiPaths.getBusinessByDate}?${new URLSearchParams(
          queryParams
        ).toString()}`
      );
      BasicInfo.isDebug && console.log("getBusinessByDate response", response);
      setBusinessData(response);
    } catch (error) {
      BasicInfo.isDebug &&
        console.error("Error fetching getBusinessByDate:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchData();
  }, []);

  const resetData = () => {
    setStartDate("");
    setEndDate("");
    setDateFilter("default");
    FetchData(true);
  };
  return (
    <>
      {loading && <Loader />}
      <section className="dashboard">
        <section className="filtersection inputPrimary">
          <Row className="gx-2 gy-2">
            <Col lg="2" md="4" xs="12">
              <input
                type="date"
                name="startDate"
                placeholder="Start Date"
                value={startDate}
                onChange={handleChange}
              />
            </Col>
            <Col lg="2" md="4" xs="12">
              <input
                type="date"
                name="endDate"
                placeholder="End Date"
                value={endDate}
                onChange={handleChange}
              />
            </Col>
            <Col lg="2" md="4" xs="12">
              <div>
                <select
                  name="dateFilter"
                  value={dateFilter}
                  onChange={handleDateFilterChange}
                >
                  <option value="default">Default</option>
                  <option value="today">Today</option>
                  <option value="yesterday">Yesterday</option>
                  <option value="this_week">This Week</option>
                  <option value="this_month">This Month</option>
                </select>
              </div>
            </Col>
            <Col lg="2" md="4" xs="6">
              <button
                style={{
                  background: "var(--btnBackground)",
                  color: "var(--btnText)",
                }}
                onClick={FetchData}
              >
                Search
              </button>
            </Col>
            <Col lg="2" md="4" xs="6">
              <button onClick={resetData}>Reset</button>
            </Col>
          </Row>
        </section>
        <Row md="12" className="gx-3 gy-3">
          <Col lg="4"></Col>
          <Col lg="4">
            <div className="wallets">
              <div className="walletsData" style={{ justifyContent: "center" }}>
                <div
                  className="walletTeams"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    textAlign: "center",
                  }}
                >
                  {/* <div className="income-card-image">
                <div>
                  <img src={Rank} alt="Rank" style={{ width: "35px" }} />
                </div>

                <div> */}
                  <h5
                    className="dashboardCardHeading"
                    style={{ textTransform: "capitalize" }}
                  >
                    Total Business From
                  </h5>
                  <h4 className="">
                    {moment(busnessData?.fromDate).format("DD MMM YY")} -{" "}
                    {moment(busnessData?.toDate).format("DD MMM YY")}
                  </h4>
                  <h5
                    className="dashboardCardHeading"
                    style={{ textTransform: "capitalize" }}
                  >
                    Is
                  </h5>
                  <h5
                    className="dashboardCardHeading"
                    style={{ textTransform: "capitalize" }}
                  ></h5>
                  <h4>
                    {BasicInfo?.Currency_sign}
                    {busnessData?.business}
                  </h4>
                </div>
              </div>
            </div>{" "}
          </Col>
          <Col lg="4"></Col>
        </Row>
      </section>
    </>
  );
};

export default BusinessReport;
